module.exports = "<ng-content select='key-value'></ng-content>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/assorted/key-value-row.component.html
// module id = ./src/app/shared/components/assorted/key-value-row.component.html
// module chunks = main